module.exports = __webpack_public_path__ + "img/logotyp_dark.ed1ffee2.png";